import { Duration } from "@js-joda/core";
import { DurationFormat } from "@formatjs/intl-durationformat";

export function getLocale(lang: string) {
  switch (lang) {
    case 'bg':
      return 'bg-BG';
    case 'en':
      return 'en-GB';
  }
}

export function formatDuration(locale: string, d: Duration): string {
  const days = d.toDays();
  const hours = d.minusDays(days).toHours();
  const minutes = d.minusHours(d.toHours()).toMinutes();
  const seconds = d.minusMinutes(d.toMinutes()).seconds();

  const fmt = new DurationFormat(locale, {
    secondsDisplay: d.isZero() ? 'always' : 'auto',
  })

  return fmt.format({ days, hours, minutes, seconds })
}